define((require) => {
    "use strict";

    const extend = require("shared/zbone/Extend");

    const Class = function() {};

    /**
     * Provides a simple mechanism for inheritance (currently wrapping Backbone"s #extend).
     *
     * Any type extended by <tt>Class</tt> will also define a "mixin({..})" function to add mixin behaviour,
     * including constructor behaviour as illustrated below. <p>
     *
     * Example of how to define a Foo object/class (notice the <tt>constructor</tt> declaration):
     *
     * <pre>
     *
     *  var Foo = Class.extend({
     *
     *      _name: null,
     *
     *      constructor: function (name) {
     *          this._name = name;
     *      },
     *
     *      hello: function () {
     *          console.log("Hello", this._name);
     *      }
     *
     *  });
     *
     *  var f = new Foo("King");
     *  f.hello(); // Hello King
     *
     * </pre>
     *
     * The second argument passed to <tt>Class.extend</tt>, defines the static fields:
     *
     * <pre>
     *
     *  var Bar = Class.extend({}, {
     *
     *      DEFAULT_VALUE: "123",
     *
     *      adjust: function (bar) {
     *          console.log("adjusting", bar);
     *          return bar;
     *      }
     *
     *  });
     *
     *  Bar.adjust(new Bar());
     *
     *  console.log(Bar.DEFAULT_VALUE);
     *
     * </pre>
     *
     * @class Class
     * @constructor
     */
    Class.extend = extend;

    // Create actual "Class"...
    return Class.extend("Class");
});



// WEBPACK FOOTER //
// ./src/shared/util/Class.js